const statsCount = {
  Countries: {
    integer: '70',
  },
  Users: {
    integer: '700,000',
    alphaNumeric: '700K',
  },
  Universities: {
    integer: '250',
  },
  localPayCountries: {
    integer: '50',
  },
};

export default statsCount;
